const messageKeys = [
  'searchbox.datepicker.day.sunday',
  'searchbox.datepicker.day.monday',
  'searchbox.datepicker.day.tuesday',
  'searchbox.datepicker.day.wednesday',
  'searchbox.datepicker.day.thursday',
  'searchbox.datepicker.day.friday',
  'searchbox.datepicker.day.saturday',
  'searchbox.button.search',
  'searchbox.button.search',
  'searchbox.datepicker.input.label.arrive',
  'searchbox.datepicker.input.label.depart',
  'searchbox.datepicker.modal.title.checkin',
  'searchbox.datepicker.modal.title.checkout',
  'searchbox.datepicker.input.label.dates',
  'searchbox.datepicker.link.clear',
  'searchbox.datepicker.modal.button.done',
  'searchbox.guests.input.label',
  'searchbox.guests.selector.adult',
  'searchbox.guests.selector.adults',
  'searchbox.guests.selector.child',
  'searchbox.guests.selector.children',
  'searchbox.guests.selector.pets',
  'searchbox.guests.input.guest',
  'searchbox.guests.input.guests',
  'searchbox.guests.selector.pets.yes',
  'searchbox.guests.selector.pets.no',
  'searchbox.guests.selector.button.apply',
  'searchbox.guests.modal.title',
  'searchbox.guests.modal.button.continue',
  'searchbox.guests.pets.message',
  'searchbox.typeahead.input.label.2',
  'noresultsfound',
  'resultsfound',
  'recentlyviewed',
  'recentsearches',
  'searchbox.typeahead.input.label.top',
  'trendingdestinations',
  'typeairport',
  'typecity',
  'typelandmark',
  'typeneighborhood',
  'typeregion',
  'typetrainstation',
  'typemetrostation',
  'destinationselected'
];

const getLabels = (
  sun,
  mon,
  tue,
  wed,
  thr,
  fri,
  sat,
  mobileTitle,
  buttonTitle,
  checkIn,
  checkOut,
  arrival,
  departure,
  dates,
  labels,
  done,
  label,
  adult,
  adults,
  child,
  children,
  pets,
  guest,
  guests,
  yesBtn,
  noBtn,
  applyBtn,
  modalTitle,
  mobileBtn,
  petMessage,
  destinationplaceholdermsg,
  noresultsfound,
  resultsfound,
  recentlyviewed,
  recentsearches,
  where,
  trendingdestinations,
  typeairport,
  typecity,
  typelandmark,
  typeneighborhood,
  typeregion,
  typetrainstation,
  typemetrostation,
  destinationselected
) => ({
  mobileTitle,
  buttonTitle,
  datePicker: {
    checkIn,
    checkOut,
    arrival,
    departure,
    dates,
    labels,
    done
  },
  guests: {
    label,
    adult,
    adults,
    child,
    children,
    pets,
    guest,
    guests,
    yesBtn,
    noBtn,
    applyBtn,
    modalTitle,
    mobileBtn,
    petMessage
  },
  typeahead: {
    destinationplaceholdermsg,
    noresultsfound,
    resultsfound,
    recentlyviewed,
    recentsearches,
    where,
    trendingdestinations,
    typeairport,
    typecity,
    typelandmark,
    typeneighborhood,
    typeregion,
    typetrainstation,
    typemetrostation,
    destinationselected
  }
});

const parseDayLabels = dayLabels => dayLabels.map(label => label.substring(0, 2));

const getCalendarLabels = (
  sun,
  mon,
  tue,
  wed,
  thr,
  fri,
  sat
) => ({
  shortDayNames: parseDayLabels([sun, mon, tue, wed, thr, fri, sat])
});

export {
  messageKeys,
  getLabels,
  getCalendarLabels
};
